import moment from 'moment';
import React from 'react';
import { Link } from 'react-scroll';
import close from '../../img/close_popup.svg';
import './CountDown.css';
import CountDown from './CountDown/CountDown.jsx';

export default class Countdown extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isCountdown: true,
			deadLine: moment.utc('2024-07-26T21:00:00+03:00'),
			scroll: 0,
			packages: [
				// {
				//     price: 'BUY 1 Ticket - GET 2 SEATS',
				//     title: 'Community Offer! ',
				// },
				// {
				//     price: 'BUY 1 Ticket - GET 2 SEATS',
				//     title: 'Community Offer! ',
				// },
				{
					price: '$179 >> $199 soon',
					title: `GeekleSummer Hot Offer. Don't Miss Out!`,
				},
				{
					price: '$179 >> $199 soon',
					title: `GeekleSummer Hot Offer. Don't Miss Out!`,
				},
				// {
				//     // price: '$99 >> $149 soon',
				//     title: 'Price Goes Up in',
				// },
				// {
				//     price: '$249 >> $299 soon',
				//     title: 'YEAR OF ARCHITECTURE ❤️',
				// },
			],
			activePackage: 0,
		};

		this.pageLink = window.location.href.toString();
		this.indexUtm = this.pageLink.indexOf('?');
		this.utm = this.pageLink.slice(this.indexUtm + 1);

		this.showCountdown = this.showCountdown.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
		this.myCallback = this.myCallback.bind(this);
	}

	myCallback() {
		if (this.state.activePackage < 1) {
			this.setState({
				activePackage: this.state.activePackage + 1,
			});
		} else {
			this.setState({
				activePackage: 0,
			});
		}
	}

	showCountdown() {
		this.setState({
			isCountdown: !this.state.isCountdown,
		});
	}

	handleScroll() {
		this.setState({
			scroll: window.scrollY,
		});
	}

	componentDidMount = () => {
		setInterval(this.myCallback, 2000);
	};

	componentWillMount = () => {
		window.addEventListener('scroll', this.handleScroll);
		return () => window.removeEventListener('scroll', this.handleScroll);
	};

	render() {
		return (
			<React.Fragment>
				{moment().isBefore(this.state.deadLine) && this.state.scroll > 500 && (
					<div>
						{this.state.isCountdown && (
							<div className='countdown-wrap red_grad'>
								<div id='countdown' className='countdown'>
									<div className='countdown-content-block'>
										<div className='countdown_text_block'>
											<p className='countdown-descr'>
												{this.state.packages[this.state.activePackage].title}
											</p>
											<p className='countdown-descr'>
												{this.state.packages[this.state.activePackage].price}
											</p>
										</div>
										<div className='countdown-main'>
											<p className='countdown-descr'>Don't miss out!</p>
											<CountDown futureDate={this.state.deadLine}></CountDown>
										</div>
										<Link
											activeClass='active'
											to='tickets'
											spy={true}
											smooth={true}
											offset={0}
											className='countdown_btn'
										>
											GET TICKET
										</Link>
									</div>
									<img
										onClick={this.showCountdown}
										className='close_countdown'
										src={close}
										alt=''
									/>
								</div>
							</div>
						)}
					</div>
				)}
			</React.Fragment>
		);
	}
}
